export default "__VITE_ASSET__b1e093ea__"